import React from 'react'
import { Card } from 'react-bootstrap'

const VRWorksExample = () => {
  return (
    <>
        <Card className="no-border rounded-0 text-center container pt-md-5 mt-md-2">
            <Card.Title className='digital-twin-title'>Examples of Our VR Development Work</Card.Title>
            <Card.Text className='digital-twin-text'>
            We have worked on hundreds of VR projects—some of which we can talk about, others which we can’t. Here are examples of the work we’ve done, with the possibilities being endless.
            </Card.Text>
        </Card>
      
    </>
  )
}

export default VRWorksExample
